import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { ToastService } from '../toast/toast.service';
import { RestError } from '../rest/rest.types';

export interface ErrorContext {
	message?: string;
}

@Injectable({
	providedIn: 'root',
})
export class ErrorService {
	constructor(
		private navCtrl: NavController,
		private toastService: ToastService
	) {}

	/**
	 * Default 404 handler: navigate home and show a toast.
	 * Called by the NotFoundInterceptor for requests that don't opt out,
	 * and by the wildcard NotFoundPage for unknown routes.
	 */
	handleNotFound(context?: ErrorContext): void {
		const message = context?.message || 'The page you were looking for could not be found.';
		this.navCtrl.navigateRoot('/home');
		this.toastService.show(message, 'bottom', undefined, undefined, [], 'error');
	}

	/**
	 * Generic API error handler for non-404 cases.
	 * Pages can call this as a fallback for errors they don't handle specifically.
	 */
	handleApiError(error: RestError, context?: ErrorContext): void {
		if (error.isNotFound) {
			this.handleNotFound(context);
			return;
		}
		const message = context?.message || 'Something went wrong. Please try again.';
		this.toastService.show(message, 'bottom', undefined, undefined, [], 'error');
	}
}
